import { render, staticRenderFns } from "./RewardsByCategoryPage.vue?vue&type=template&id=391b4bbf&scoped=true&"
import script from "./RewardsByCategoryPage.vue?vue&type=script&lang=js&"
export * from "./RewardsByCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./RewardsByCategoryPage.vue?vue&type=style&index=0&id=391b4bbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b4bbf",
  null
  
)

export default component.exports